module.exports = __webpack_public_path__ + "static/media/euta_ye.059d6ec3.ogg";